import { api, homepagee as homepage } from '../package.json'

const config = {
    //WS_BASE_URL: 'http://localhost:54321/api/',
    //DOMAIN_NAME: 'http://localhost:3000',
    //USER_FILES: 'http://localhost:54321/userfiles/',
    WS_BASE_URL: api,
    DOMAIN_NAME: homepage,
    USER_FILES: homepage + '/userfiles/',
    DEMO: false,
}

export default config;